import { useMemo, useState } from "react";
import { Checkbox } from "@/components/ui/checkbox";
import * as Icons from "@/assets/features/candidates";
import BaseModal from "@/components/shared/modals/BaseModal";
import { useTranslation } from "react-i18next";

export default function ExportModal({ open, onOpenChange }) {
  const { t } = useTranslation();
  const [originalFormat, setOriginalFormat] = useState(true);
  const [originalTemplate, setOriginalTemplate] = useState(true);

  const exportOptions = useMemo(
    () => [
      { id: "pdf", label: t("common.exportModal.optionPdf"), icon: Icons.PdfDocument },
      { id: "excel", label: t("common.exportModal.optionExcel"), icon: Icons.Excal },
      { id: "xml", label: t("common.exportModal.optionXml"), icon: Icons.Xml },
      {
        id: "template",
        label: t("common.exportModal.optionTemplate"),
        icon: Icons.CV,
      },
    ],
    [t]
  );

  const handleExport = () => {
    console.log("Exporting file...");
    console.log("Original Format:", originalFormat);
    console.log("Original Template:", originalTemplate);
    onOpenChange(false);
  };

  return (
    <BaseModal
      open={open}
      onClose={() => onOpenChange(false)}
      onConfirm={handleExport}
      title={t("common.exportModal.title")}
      textBtn={t("common.exportModal.exportBtn")}
    >
      <div className="space-y-3 text-md text-secondary pb-4">
        <p className="text-sm text-black">{t("common.exportModal.shareAs")}</p>

        {exportOptions.map(({ id, label, icon: Icon }) => (
          <div
            key={id}
            className="border border-[#B9CCE2] rounded-[1rem] p-3 flex items-center gap-3 hover:bg-gray-50 cursor-pointer"
          >
            <Icon className="w-6 h-6" />
            <span>{label}</span>
          </div>
        ))}

        <div className="flex items-center gap-4 pt-2">
          <label className="flex items-center gap-2 text-sm cursor-pointer">
            <Checkbox checked={originalFormat} onCheckedChange={(val) => setOriginalFormat(!!val)} />
            {t("common.exportModal.originalFormat")}
          </label>
          <label className="flex items-center gap-2 text-sm cursor-pointer">
            <Checkbox checked={originalTemplate} onCheckedChange={(val) => setOriginalTemplate(!!val)} />
            {t("common.exportModal.originalTemplate")}
          </label>
        </div>
      </div>
    </BaseModal>
  );
}
